import { addSeconds } from 'date-fns';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BrandS, BrandXS, BrandXXL } from '#src/atoms/typography/index.tsx';
import { Countdown } from '#src/components/Countdown/index.tsx';
import { useConfigContext } from '#src/contexts/config/index.ts';
import type { FlagSet } from '#src/contexts/featureFlags/index.ts';
import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';

const CountdownLabel = styled(BrandXXL)`
  font-variant-numeric: tabular-nums;
`;
const CountdownCaption = styled(BrandXS).attrs({
  color: 'var(--c-nd-600)',
})``;

export const useNextSetStartTimer = () => {
  const { cardSet } = useConfigContext();
  const { flags } = useFeatureFlags<
    FlagSet & { hideNextCardSetTimer?: boolean }
  >();
  const hideNextCardSetTimer = flags.hideNextCardSetTimer ?? false;
  const currentSet = cardSet?.currentSet;
  const nextSet = cardSet?.nextSet;

  const showTimer =
    !hideNextCardSetTimer && !currentSet && !!nextSet?.startDate;
  const starts = !(showTimer && nextSet?.startDate);

  return {
    showTimer,
    starts,
    currentSet,
    nextSet,
    nextSetStartDate: nextSet?.startDate,
  };
};

type Props = {
  onEnded?: () => void;
};

export const NextSetStartCountdown = ({ onEnded }: Props) => {
  const { showTimer, nextSetStartDate } = useNextSetStartTimer();

  if (!showTimer || !nextSetStartDate) {
    return null;
  }

  return (
    <Vertical center gap={1.5}>
      <BrandS>
        <FormattedMessage defaultMessage="begins in" />
      </BrandS>
      <Countdown
        date={addSeconds(nextSetStartDate, 10)}
        Label={CountdownLabel}
        Caption={CountdownCaption}
        gap={3}
        onEnded={onEnded}
      />
    </Vertical>
  );
};
